class ToplineUserMenu {
    constructor() {
        this.closeMobileMenu = this.closeMobileMenu.bind(this)

        this.checkbox = document.querySelector('#topline-user-menu-checkbox')

        if (this.checkbox) {
            this.checkbox.addEventListener('change', e => {
                document[e.target.checked ? 'addEventListener' : 'removeEventListener']('click', this.closeMobileMenu)
            })
        }
    }

    closeMobileMenu(e) {
        const label = e.target.closest('label')

        if (label && label.control === this.checkbox) {
            return
        }

        this.checkbox.checked = false
        this.checkbox.dispatchEvent(new Event('change'))
    }
}

export default new ToplineUserMenu()
